module.exports = __webpack_public_path__ + "static/MOD-520-Politica_qualita-2e539427baad3cbde68faf0ad36d07fd.pdf";